import { useToastStore } from '@/common/stores/useToastStore';

export const showErrorToast = (title: string, message: string) => {
  useToastStore.getState().showToast({
    type: 'danger',
    title,
    message,
    duration: 5,
  });
};
